import {repeat} from 'lit-html/directives/repeat';
import flags from './images/flags.png';

export default (ctx, html) => html`
  <div class="phone-input" value="+${ctx.selected.phone_code} ${ctx.phoneLocal}">
    <div class="phone-input-flag-container ${(ctx.disabled && ctx.phoneLocal === '') ? 'd-none' : ''}" role="combobox">
      <div class="phone-input-selected" @click="${() => ctx.showList()}" style="${ctx.disabled ? 'cursor: default;' : ''}">
        <div class="phone-input-selected-flag" style="background-image: url(${flags}); background-position-x: -${ctx.selected.offset * 0.2}px;"></div>
        <div class="phone-input-selected-code">+${ctx.selected.phone_code}</div>
        <div class="phone-input-selected-arrow ${ctx.disabled ? 'd-none' : ''}"></div>
      </div>
      <ul class="phone-input-country-list ${ctx.toggleList ? '' : 'd-none'}" role="listbox" aria-label="List of Countries">
        ${repeat(ctx.countries, (country) => country.iso, (country, index) => html`
          <li class="phone-input-country-element" role="option" data-iso="${country.iso}" aria-selected="${ctx.selected.iso === country.iso}" @click="${(e) => ctx.selectCode(country.iso, e)}">
            <div class="phone-input-flag-box" style="background-image: url(${flags}); background-position-x: -${country.offset * 0.2}px;"></div>
            <span class="phone-input-name">${country.name}</span>
            <span class="phone-input-code">+${country.phone_code}</span>
          </li>
        `)}
      </ul>
    </div>
    <input
      type="tel"
      autocomplete="off"
      class="phone-input-number"
      @change="${(e) => ctx.updatePhoneLocal(e)}"
      @keyup="${(e) => ctx.updatePhoneLocal(e)}"
      @click="${ctx.hideList}" value="${ctx.phoneLocal}"
      ?disabled="${ctx.disabled}"
      maxlength="17"
      placeholder="${ctx.placeholder}"
      aria-label="Phone"
    >
  </div>
`;
